/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useCallback, useRef, useEffect } from 'react'
import {
  Layout,
  Table,
  Avatar,
  Input,
  Button,
  Modal,
  Checkbox,
  Radio,
  Divider,
  message
} from 'antd'
import { LockOutlined } from '@ant-design/icons'
import { fetchVerifyCode } from '../../actions/main'
import {
  grantAdmin,
  revokeAdmin,
  transferMasterAdmin
} from '../../actions/team'
import CONFIG from '../../constants/config'
import * as SentryUtils from '../../utils/sentryUtils'
import crown_btn_icon from '../../images/btn-crown-icon.png'
import {
  useAppDispatch,
  useAppSelector,
  usePayment,
  useVip
} from '../../app/hooks'
import { Status } from '../../utils/exceptionHelper'

import PageHeader from '@/components/PageHeader'
const { Content } = Layout
const { Column } = Table
const { Search } = Input

interface GrantAdminButtonProps {
  onClick: () => void
}

interface MemberRecord {
  user_id: string
  headimgurl: string
  nickname: string
  mobile?: string
  role_type?: number
  user_status?: number
  key?: string
  sex?: number
  [key: string]: unknown
}

const GrantAdminButton: React.FC<GrantAdminButtonProps> = ({ onClick }) => {
  const { isVip, isSVip } = useVip()
  const payment = usePayment()
  const members = useAppSelector((state) => state.group.members)

  const handleGrantAdminClick = useCallback(() => {
    const adminCount = members.filter(
      (member) =>
        member.role_type === CONFIG.memberRoleTypes.ADMIN ||
        member.role_type === CONFIG.memberRoleTypes.MASTER_ADMIN
    ).length
    // const canGrantAdmin =
    //   isSVip || adminCount < CONFIG.vipPrivilege.adminNum.noVip
    if (!isVip && adminCount >= CONFIG.vipPrivilege.adminNum.noVip) {
      payment.open('webGroupManegerNum')
    } else if (
      isVip &&
      !isSVip &&
      adminCount >= CONFIG.vipPrivilege.adminNum.vip
    ) {
      payment.openSvip('webGroupManegerNum')
    } else {
      onClick()
    }
    // if (canGrantAdmin) {
    //   onClick()
    // } else {
    //   payment.openSvip('webGroupManegerNum')
    // }
  }, [isVip, isSVip, members, onClick, payment])

  return (
    <Button type="primary" onClick={handleGrantAdminClick}>
      添加管理员
      <img style={{ width: 20, marginBottom: 2 }} src={crown_btn_icon} />
    </Button>
  )
}

function Admin() {
  const dispatch = useAppDispatch()
  const user = useAppSelector((state) => state.main.user)
  const members = useAppSelector((state) => state.group.members)
  const groupId = useAppSelector((state) => state.group.groupId)
  const isVip = useAppSelector((state) => state.group.isVip)
  const isSVip = useAppSelector(
    (state) =>
      state.group.isVip &&
      state.group.vipInfo?.vip_kind === CONFIG.VIP_KIND.SVIP
  )

  const [search, setSearch] = useState('')
  const [checkedMembers, setCheckedMembers] = useState<string[]>([])
  const [grantSearch, setGrantSearch] = useState('')
  const [grantCheckedMembers, setGrantCheckedMembers] = useState<
    MemberRecord[]
  >([])
  const [grantModalVisible, setGrantModalVisible] = useState(false)
  const [transferModalVisible, setTransferModalVisible] = useState(false)
  const [newMasterAdmin, setNewMasterAdmin] = useState('')
  const [transferSearch, setTransferSearch] = useState('')
  const [verifyCode, setVerifyCode] = useState('')
  const [counting, setCounting] = useState(false)
  const [count, setCount] = useState(59)

  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null)

  // 清理定时器
  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [])

  const handleSearch = (value: string) => {
    setSearch(value)
  }

  const handleGrantCheckedMember = (member: MemberRecord, checked: boolean) => {
    if (checked) {
      setGrantCheckedMembers((prev) => [...prev, member])
    } else {
      setGrantCheckedMembers((prev) =>
        prev.filter((checkedMember) => checkedMember.user_id !== member.user_id)
      )
    }
  }

  const handleGrantModalClose = () => {
    setGrantModalVisible(false)
    setGrantSearch('')
    setGrantCheckedMembers([])
  }

  const handleTransferModalClose = () => {
    setTransferModalVisible(false)
    setTransferSearch('')
    setNewMasterAdmin('')
  }

  const handleGrantAdmin = () => {
    dispatch(
      grantAdmin({
        group_id: groupId,
        user_list: grantCheckedMembers.map((member) => member.user_id)
      })
    )
      .then((data) => {
        if (data.status === 0) {
          handleGrantModalClose()
        } else if (data.status === Status.svipForbiden) {
          //TODO
          message.error(
            `添加${
              CONFIG.vipPrivilege.adminNum.vip - 1
            }个及以上管理员为团队"超级会员"权益，您暂时无法享受此权益`
          )
        }
      })
      .catch((err) => SentryUtils.capturePromiseException(err))
  }

  const handleRevokeAdmin = (user_list: string[] = checkedMembers) => {
    Modal.confirm({
      title: '是否撤销其管理员身份？',
      cancelText: '取消',
      okText: '撤销',
      okType: 'danger',
      onOk: () =>
        dispatch(
          revokeAdmin({
            group_id: groupId,
            user_list
          })
        )
          .then(() => {
            setCheckedMembers([])
          })
          .catch((err) => SentryUtils.capturePromiseException(err))
    })
  }

  const handleTransferMasterAdmin = () => {
    dispatch(
      transferMasterAdmin({
        userID: user?.user_id,
        groupID: groupId,
        toUserID: newMasterAdmin,
        mobile: user?.mobile,
        veriCode: verifyCode
      })
    )
      .then(() => window.location.reload())
      .catch((err) => SentryUtils.capturePromiseException(err))
  }

  const handleCounting = () => {
    setCounting(true)
    intervalRef.current = setInterval(() => {
      setCount((prevCount) => {
        if (prevCount > 0) {
          return prevCount - 1
        } else {
          handleClearCounting()
          return 59
        }
      })
    }, 1000)
  }

  const handleClearCounting = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current)
    }
    intervalRef.current = null
    setCounting(false)
    setCount(59)
  }

  const handleFetchVerifyCode = () => {
    dispatch(
      fetchVerifyCode({
        mobile: user?.mobile
      })
    )
      .then((data) => {
        switch (data.status) {
          case 0:
            //0 发送验证码成功
            handleCounting()
            break
          case -31:
            //-31 没有找到手机号对应用户
            message.error(
              '该手机号未注册，请打开今日水印相机APP，注册开通团队功能。'
            )
            break
          case -32:
            //-32 该用户没有加入任何团队
            message.error(
              '该手机号未注册，请打开今日水印相机APP，注册开通团队功能。'
            )
            break
          case -19:
            //-19 发送验证码失败
            message.error('验证码发送失败，请重试')
            break
          case -27:
            //-27 验证码发送次数已超出今日限制，请明日重试
            message.error('验证码发送次数已超出今日限制，请明日重试')
            break
          default:
            break
        }
      })
      .catch(SentryUtils.capturePromiseException)
  }

  const rowSelection = {
    selectedRowKeys: checkedMembers,
    onChange: (selectedRowKeys: React.Key[]) => {
      setCheckedMembers(selectedRowKeys as string[])
    },
    getCheckboxProps: (record: MemberRecord) => ({
      disabled: record.user_id === user?.user_id || record.role_type === 1 // Current user and master admin can not be removed.
    })
  }
  const locale = {
    emptyText: '暂无管理员'
  }
  const source = members
    .filter((member) => (member.role_type ?? 0) > 0)
    .filter((member) => member.user_status === CONFIG.memberStatus.NORMAL)
    .filter((member) => (member.nickname ?? '').indexOf(search) > -1)
    .map((data) => {
      return {
        ...data,
        key: data.user_id
      }
    })

  const adminCount = members.filter(
    (member) =>
      member.role_type === CONFIG.memberRoleTypes.ADMIN ||
      member.role_type === CONFIG.memberRoleTypes.MASTER_ADMIN
  ).length

  // const overSvipLimit = !isSVip && adminCount + grantCheckedMembers.size > 2
  const overVipLimit =
    !isVip &&
    adminCount + grantCheckedMembers.length > CONFIG.vipPrivilege.adminNum.noVip
  const overSvipLimit =
    !isSVip &&
    adminCount + grantCheckedMembers.length > CONFIG.vipPrivilege.adminNum.vip

  return (
    <Layout className="Admin">
      <PageHeader
        className="Header"
        ghost={true}
        title="管理员设置"
        extra={
          <div className="members-header">
            {checkedMembers.length > 0 && (
              <>
                <p className="count">已选择{checkedMembers.length}人</p>
                <p className="cancel" onClick={() => setCheckedMembers([])}>
                  取消选择
                </p>
                <Button danger onClick={() => handleRevokeAdmin()}>
                  撤销管理员
                </Button>
              </>
            )}
            <GrantAdminButton onClick={() => setGrantModalVisible(true)} />
          </div>
        }
      />
      <Content className="content">
        <div className="Filter">
          <div className="filter-wrapper">
            <div className="search-wrapper">
              <Search
                className="search"
                placeholder="按姓名搜索管理员"
                onSearch={handleSearch}
                allowClear
                enterButton
              />
            </div>
          </div>
        </div>
        <Table
          rowSelection={rowSelection}
          dataSource={source}
          locale={locale}
          pagination={false}
        >
          <Column
            width="360px"
            title="姓名"
            key="nickname"
            render={(text, record) => (
              <div className="column-name">
                <Avatar shape="square" src={record.headimgurl} />
                <span>{record.nickname}</span>
              </div>
            )}
          />
          <Column width="240px" title="手机" key="mobile" dataIndex="mobile" />
          <Column
            width="180px"
            title="类型"
            key="type"
            render={(_text: unknown, record: MemberRecord) => (
              <span>
                {
                  CONFIG.memberRoles.find(
                    (role) => role.id === record.role_type
                  )?.role
                }
              </span>
            )}
          />
          <Column
            title="操作"
            key="action"
            render={(text, record) => {
              if (
                record.user_id !== user?.user_id &&
                record.role_type === CONFIG.memberRoleTypes.ADMIN
              ) {
                return (
                  <span>
                    <a
                      style={{ color: '#ff4451' }}
                      onClick={() => handleRevokeAdmin([record.user_id])}
                    >
                      撤销管理员
                    </a>
                  </span>
                )
              }
              if (
                record.user_id === user?.user_id &&
                record.role_type === CONFIG.memberRoleTypes.MASTER_ADMIN &&
                members.filter(
                  (member) => member.user_status === CONFIG.memberStatus.NORMAL
                ).length > 1
              ) {
                return (
                  <span>
                    <a
                      style={{ color: '#207AFF' }}
                      onClick={() => setTransferModalVisible(true)}
                    >
                      转让主管理员
                    </a>
                  </span>
                )
              }
            }}
          />
        </Table>
        <div id="modal-container">
          <Modal
            title="添加管理员"
            getContainer={() =>
              document.getElementById('modal-container') || document.body
            }
            open={grantModalVisible}
            onCancel={handleGrantModalClose}
            footer={[
              <span
                key="count"
                style={{
                  float: 'left',
                  lineHeight: '32px',
                  color:
                    overSvipLimit || overVipLimit
                      ? 'red'
                      : 'rgba(0, 0, 0, 0.65)'
                }}
              >
                已选{grantCheckedMembers.length}人
                {/* {overSvipLimit && `，开通超级会员可解锁2人数量限制`} */}
                {overSvipLimit
                  ? `，开通超级会员可解锁${CONFIG.vipPrivilege.adminNum.vip}人数量限制`
                  : overVipLimit
                    ? `，开通会员可解锁${CONFIG.vipPrivilege.adminNum.noVip}人数量限制`
                    : ''}
              </span>,
              <Button key="cancel" onClick={handleGrantModalClose}>
                取消
              </Button>,
              <Button
                key="submit"
                type="primary"
                disabled={
                  grantCheckedMembers.length === 0 ||
                  overSvipLimit ||
                  overVipLimit
                }
                onClick={handleGrantAdmin}
              >
                设为管理员
              </Button>
            ]}
          >
            <div className="grant-admin-modal">
              <Search
                className="search"
                allowClear
                placeholder="搜索成员"
                onSearch={(value) => setGrantSearch(value)}
                enterButton
              />
              <div className="member-list">
                {members
                  .filter(
                    (member) =>
                      member.user_status === CONFIG.memberStatus.NORMAL
                  )
                  .filter((member) => member.role_type === 0)
                  .filter(
                    (member) =>
                      (member.nickname ?? '').indexOf(grantSearch) > -1
                  )
                  .map((member, index) => {
                    const userId = member.user_id
                    const headimgurl = member.headimgurl
                    const nickname = member.nickname
                    const roleType = member.role_type ?? 0
                    return (
                      <div className="member" key={index}>
                        <Checkbox
                          checked={grantCheckedMembers.some(
                            (checkedMember) => checkedMember.user_id === userId
                          )}
                          onChange={(e) =>
                            handleGrantCheckedMember(
                              {
                                user_id: userId,
                                headimgurl,
                                nickname,
                                role_type: roleType
                              },
                              e.target.checked
                            )
                          }
                        />
                        <Avatar
                          className="avatar"
                          shape="square"
                          src={headimgurl}
                        />
                        <span className="nickname">{nickname}</span>
                      </div>
                    )
                  })}
              </div>
            </div>
          </Modal>
          <Modal
            title="转让主管理员"
            getContainer={() =>
              document.getElementById('modal-container') || document.body
            }
            open={transferModalVisible}
            okText="设为主管理员"
            onOk={handleTransferMasterAdmin}
            okButtonProps={{
              disabled: !newMasterAdmin || !verifyCode
            }}
            onCancel={handleTransferModalClose}
          >
            <div className="grant-admin-modal">
              <Search
                className="search"
                allowClear
                placeholder="搜索成员"
                onSearch={(value) => setTransferSearch(value)}
                enterButton
              />
              <div className="member-list">
                {members
                  .filter(
                    (member) =>
                      member.user_status === CONFIG.memberStatus.NORMAL
                  )
                  .filter((member) => member.user_id !== user?.user_id)
                  .filter((member) =>
                    (member.nickname ?? '').includes(transferSearch)
                  )
                  .map((member, index) => (
                    <div className="member" key={index}>
                      <Radio.Group
                        value={newMasterAdmin}
                        onChange={(e) => setNewMasterAdmin(e.target.value)}
                      >
                        <Radio value={member.user_id}>
                          <Avatar
                            className="avatar"
                            shape="square"
                            src={member.headimgurl}
                          />
                          <span className="nickname">{member.nickname}</span>
                        </Radio>
                      </Radio.Group>
                    </div>
                  ))}
              </div>
              <div>
                <Divider>手机号码验证</Divider>
                <div style={{ paddingLeft: '24px' }}>
                  <p>请输入&nbsp;{user?.mobile}&nbsp;收到的验证码</p>
                  <Input
                    size="large"
                    prefix={
                      <LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />
                    }
                    placeholder="验证码"
                    pattern="[0-9]*"
                    maxLength={4}
                    suffix={
                      counting ? (
                        <span className="count">重新获取（{count}秒）</span>
                      ) : (
                        <Button
                          type="link"
                          onClick={handleFetchVerifyCode}
                          disabled={counting || !newMasterAdmin}
                        >
                          获取验证码
                        </Button>
                      )
                    }
                    value={verifyCode}
                    onChange={(e) => setVerifyCode(e.target.value.trim())}
                  />
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </Content>
    </Layout>
  )
}

export default Admin
